var _rect, _rect2, _rect3, _g, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPartners = function SvgPartners(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "#4E4B59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2112,
    y: -795,
    width: 5721,
    height: 2729,
    fill: "#4E4B59"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1314,
    transform: "translate(-37 -354)",
    fill: "#4E4B59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_381_221)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37,
    y: -354,
    width: 244,
    height: 1315,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7947 2.24131L23.0549 2.24283C21.3946 2.24979 20.3676 1.94233 19.585 1.62029C18.803 1.29773 18.2891 0.895457 17.505 0.756244C16.6685 0.608285 15.276 0.555414 13.6925 1.44634C12.9526 0.924438 12.2652 0.675954 11.5946 0.597655C10.932 0.520245 10.3094 0.575302 9.59465 0.595129C9.5876 0.596435 9.5833 0.608619 9.57728 0.611045C8.55405 0.637275 7.54409 0.765757 6.45006 0.221901L5.98907 0L0 5.48687L9.78723 16.1699C10.3815 16.7521 11.1949 16.7883 11.8502 16.6631C12.5044 16.5379 13.0881 16.2659 13.5265 15.9973C14.6451 15.3147 17.6855 13.1529 17.6855 13.1529L17.754 13.1231L17.8067 13.0748C18.1691 12.7098 18.3481 12.2593 18.468 11.7917L20.9191 10.7058L23.3404 10.3244L24 10.2355L23.995 9.56283L23.8136 2.96513L23.7947 2.24131ZM22.2859 3.68851L22.4251 8.93951L20.5816 9.21118L20.4806 9.20784L20.3767 9.27L18.4058 10.1418C18.2722 9.77663 18.0989 9.43337 17.8105 9.14102L17.7781 9.10572L14.5201 5.58434L14.0067 5.02394L11.8351 7.01342C11.1524 7.49459 10.6048 7.37164 10.049 7.10363C9.86401 7.01539 9.87891 6.96978 9.74014 6.87118L12.9967 3.88772C14.9899 1.89259 16.2656 2.08451 17.2376 2.25776C17.5066 2.30504 18.0771 2.64309 19.0024 3.02409C19.7765 3.34147 20.8835 3.60347 22.2859 3.68851ZM12.3356 2.49673C12.2064 2.61104 12.0802 2.65339 11.953 2.78231L7.46976 6.88963L7.98318 7.45004C7.98318 7.45004 8.53926 8.04351 9.38528 8.45279C10.2308 8.86151 11.5425 9.08944 12.7218 8.26259L13.9127 7.17158L16.6897 10.1679L16.7056 10.1852C16.9444 10.4189 17.081 10.7377 17.0853 11.0718C17.0896 11.4059 16.9614 11.7281 16.7287 11.9679C16.7177 11.9739 16.4862 12.1386 16.434 12.1739L14.3321 9.87963L13.2113 10.9065L15.1849 13.0607C14.6973 13.3981 14.3757 13.5928 13.9034 13.9121L12.0905 11.9333L10.9697 12.9601L12.6224 14.7641C12.2906 14.9462 11.9334 15.0778 11.5628 15.1545C11.1732 15.23 10.9584 15.1845 10.8439 15.073L2.14764 5.58085L6.33332 1.74615C7.64752 2.21304 8.85826 2.14283 9.61108 2.12521C10.3919 2.10666 10.9585 2.06583 11.4102 2.12002C11.705 2.15605 12.025 2.3422 12.3356 2.49673Z",
    fill: "#4E4B59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_381_221",
    x: -37,
    y: -354,
    width: 244,
    height: 1315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_381_221"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartners, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partners.a4942c06.svg";
export { ForwardRef as ReactComponent };